import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../Button/Button.js';
import { runningInApp, isIos } from '../../../services/appConstants/appConstants.js';
import styles from './NavigationBar.module.scss.js';

function NavigationBar(_ref) {
  var onNext = _ref.onNext,
    nextText = _ref.nextText,
    nextDisabled = _ref.nextDisabled,
    isLoading = _ref.isLoading,
    infoText = _ref.infoText,
    dataTestId = _ref.dataTestId;
  var inset = !isIos && runningInApp ? '8px' : '25px';
  var pushUp = infoText ? '150px' : '75px';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "pushUpContent",
    style: {
      minHeight: pushUp
    }
  }), /*#__PURE__*/React.createElement("section", {
    className: classNames(runningInApp ? styles.wizardNavigationBar : styles.wizardNavigationBarDesktop),
    style: {
      paddingBottom: inset
    }
  }, infoText !== '' && /*#__PURE__*/React.createElement("p", {
    className: styles.infoText
  }, infoText), /*#__PURE__*/React.createElement(Button, {
    isLoading: isLoading,
    text: nextText,
    onClick: onNext,
    className: classNames(styles.button),
    disabled: nextDisabled,
    dataTestId: dataTestId,
    red: true
  })));
}
NavigationBar.propTypes = {
  onNext: PropTypes.func.isRequired,
  nextText: PropTypes.string.isRequired,
  nextDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  infoText: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  dataTestId: PropTypes.string
};
NavigationBar.defaultProps = {
  nextDisabled: false,
  isLoading: false,
  infoText: '',
  dataTestId: 'navigationBarNext'
};

export { NavigationBar as default };
